var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":"","color":_vm.popupColor},scopedSlots:_vm._u([{key:"activator",fn:function({on}){return [_c('v-icon',_vm._g({attrs:{"color":_vm.iconColor}},on),[_vm._v(_vm._s(_vm.icon))])]}}])},[_c('span',{staticClass:"whitespace-pre"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }